// extracted by mini-css-extract-plugin
module.exports = {"social":"_38cLOEImM92lAToIgBNZlU","header":"_2NGFliAxMHVfpw99JtFJRW","socialItem":"_3-h9G1XSMT6ULGHAFJy8Z8"};